import { makeStyles, } from '@fluentui/react-components';

export const useEmptyStateStyle = makeStyles({
  emptyStateWrap: {
    '& .content-subtext': {
      marginTop: '10px',
    },
  },
  emptyStateLink: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
  },
});
